<template>
  <svg class="icon arrow-long" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 15">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.859.745a1.164 1.164 0 0 1 1.645 0l5.822 5.821a1.164 1.164 0 0 1 0 1.646l-5.822 5.822a1.164 1.164 0 1 1-1.645-1.646l3.834-3.834H1.56a1.164 1.164 0 0 1 0-2.33h25.134L22.86 2.39a1.164 1.164 0 0 1 0-1.645Z" fill="#000"/>
  </svg>
</template>
